import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class AgileFolderViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.AGILE_FOLDER_VIEW = '/api/agile-folder-view';
        this.GET_BY_ID = '/id/{id}';
        this.GET_LIST_BY_PROJECT = '/list/project/{projectId}';
        this.GET_LIST_BY_CONNECTION_ID = '/list/connection/{connectionId}';

    }

    async getById(id) {
        try {
            let url = window.location.origin + this.AGILE_FOLDER_VIEW + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getByProject(projectId) {
        try {
            let url = window.location.origin + this.AGILE_FOLDER_VIEW + this.GET_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId)
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getByConnection(connectionId) {
        try {
            let url = window.location.origin + this.AGILE_FOLDER_VIEW + this.GET_LIST_BY_CONNECTION_ID;
            url = url
                .replace('{connectionId}', connectionId)
            const fileDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return fileDataRet;
        } catch (err) {
            console.log(err);
        }
    }
}

export default AgileFolderViewService;
